import { useState } from "react";
import { Link } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { supabase } from "utils/supabase";
import enarmApexLogo from "assets/img/enarm-apex-logo.png";

export default function RecuperarContrasena() {
	const [email, setEmail] = useState("");
	const [errorMessage, setErrorMessage] = useState("");
	const [successMessage, setSuccessMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const handleRecoverPassword = async (e) => {
		e.preventDefault();
		setErrorMessage("");
		setSuccessMessage("");

		if (!email.trim()) {
			setErrorMessage("Por favor ingresa tu correo electronico.");
			return;
		}

		setLoading(true);

		const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
			redirectTo: `${window.location.origin}/auth/restablecer-contrasena`,
		});

		setLoading(false);

		if (error) {
			setErrorMessage("No pudimos enviar el correo de recuperacion. Intenta de nuevo.");
			console.error(error);
			return;
		}

		setSuccessMessage(
			"Te enviamos un correo con instrucciones para restablecer tu contrasena."
		);
	};

	return (
		<>
			<div className="container mx-auto px-4 h-full">
				<div className="flex content-start items-start justify-center h-full">
					<div className="w-full lg:w-4/12 px-4 -mt-20">
						<div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0">
							<div className="rounded-t mb-0 px-6 py-6">
								<div className="text-center mb-3">
									<img
										src={enarmApexLogo}
										alt="ENARM Apex Logo"
										className="w-32 mx-auto"
										style={{ width: "20rem" }}
									/>
									<br />
									<h6 className="text-blueGray-500 text-lg font-bold">
										Recuperar contraseña
									</h6>
									<p className="text-sm text-blueGray-500 mt-2">
										Ingresa tu correo y te enviaremos un enlace para restablecerla.
									</p>
								</div>
							</div>

							<div className="flex-auto px-4 lg:px-10 py-10 pt-0">
								<form onSubmit={handleRecoverPassword}>
									{successMessage && (
										<Alert severity="success" className="mb-4">
											{successMessage}
										</Alert>
									)}

									{errorMessage && (
										<Alert severity="error" className="mb-4">
											{errorMessage}
										</Alert>
									)}

									<div className="relative w-full mb-3">
										<label
											className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
											htmlFor="recover-email"
										>
											Email
										</label>
										<input
											id="recover-email"
											type="email"
											className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
											placeholder="Email"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
										/>
									</div>

									<div className="text-center mt-6">
										<button
											className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 disabled:opacity-60"
											type="submit"
											disabled={loading}
										>
											{loading ? "Enviando..." : "Enviar correo de recuperacion"}
										</button>
									</div>
								</form>
							</div>
						</div>

						<div className="text-center mt-2">
							<Link to="/auth/login" className="text-blueGray-200">
								<small>Volver a iniciar sesion</small>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
